import React, { useState, useEffect } from "react";
import "./Setprice.scss";
import Steppers from "../../components/Stepper/Stepper";
import Container from "../../Container/Container";
import Slider from "../../components/Slider/Slider";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { productData } from "../../store/action";
import { useTranslation } from "react-i18next";
import { API, graphqlOperation } from "aws-amplify";
import {
  createProductTable,
  updateProductTable,
} from "../../graphql/mutations";
import Snackbar from "../../components/Snackbar/Snackbar";
import { Storage } from "aws-amplify";
import { draftId } from "../../store/action/index";
const Setprice = () => {
  const { t } = useTranslation();

  const days = [
    {
      value: 0,
      label: t("days"),
    },
    {
      value: 5,
      label: "5",
    },
    {
      value: 10,
      label: "10",
    },
    {
      value: 15,
      label: "15",
    },
    {
      value: 20,
      label: "20",
    },
    {
      value: 25,
      label: "25",
    },
    {
      value: 30,
      label: "30",
    },
  ];

  const sales = [
    {
      value: 5,
      label: "5pcs",
    },
    {
      value: 25,
      label: "25pcs",
    },
    {
      value: 50,
      label: "50pcs",
    },
    {
      value: 75,
      label: "75pcs",
    },
    {
      value: 100,
      label: "100 + pcs",
    },
  ];
  const login = useSelector((state) => state.login);
  const product = useSelector((state) => state.product);
  const draftProductId = useSelector((state) => state.draftId.draftProductId);
  const [describe, setdescribe] = useState(false);
  const [day, setday] = useState(product.day > 0 ? product.day : 0);
  const [target, settarget] = useState(product.target > 0 ? product.target : 5);
  const dispatch = useDispatch();
  const [price, setprice] = useState();
  const [gain, setgain] = useState(0);
  const [tgain, settgain] = useState(0);
  const [campaignstyle, setcampaignstyle] = useState(false);
  const [loader, setLoader] = useState(false);
  const campaigns_array = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  const [campaign, setcampaign] = useState(
    product.campaign > 0 ? product.campaign : 4
  );
  const [err, seterr] = useState(false);
  const history = useHistory();
  const [msg, setmsg] = useState("");
  const [errMsg, seterrMsg] = useState("");
  useEffect(() => {
    setprice(
      product?.shirtdesign[0]?.preview && product?.shirtdesignback[0]?.preview
        ? parseInt(product?.shirt?.cost + 5)
        : product?.shirtdesign[0]?.preview &&
          !product?.shirtdesignback[0]?.preview
        ? parseInt(product?.shirt?.cost + 5)
        : product?.shirtdesignback[0]?.preview &&
          !product?.shirtdesign[0]?.preview
        ? parseInt(product?.shirt?.cost + 5)
        : product?.shirt?.cost
    );
  }, [product?.shirt?.cost]);

  useEffect(() => {
    dispatch(
      productData({
        step: 2,
      })
    );
  }, []);

  useEffect(() => {
    if (
      product?.shirtdesign[0]?.preview &&
      product?.shirtdesignback[0]?.preview
    ) {
      dispatch(
        productData({
          ...product,
          shirt: { ...product.shirt, cost: product.hello.cost + 5 },
        })
      );
    }
  }, []);

  const describeroute = () => {
    // console.log("price==>", price);
    if (price && price > product.shirt.cost && day && target && campaign) {
      setLoader(true);
      dispatch(
        productData({
          realprice: product.shirt.cost,
          day: day,
          target: target,
          campaign: campaign,
          sellingPrice: price,
        })
      );
      setdescribe(true);
    } else {
      seterrMsg(t("select-all-field"));
      setTimeout(() => {
        seterrMsg("");
      }, 2000);
    }
  };

  useEffect(() => {
    if (describe) {
      addProductStep2();
    }
  }, [describe]);

  const designroute = () => {
    history.push("/design");
  };
  const status = login.loginStatus;
  const earning = () => {
    setgain(parseInt(price - product.shirt.cost));
    settgain(parseInt(gain * target * campaign));
  };
  useEffect(() => {
    earning();
  }, [campaign, price, target, gain, tgain, product.shirt.cost]);

  const No_compaigns = (val) => {
    setcampaign(val);
    setcampaignstyle(false);
  };

  useEffect(() => {
    if (price === 0) {
      seterr(false);
    } else if (price < product.shirt.cost) {
      seterr(true);
    } else {
      seterr(false);
    }
  }, [price]);

  const addProductStep2 = async () => {
    setLoader(true);
    const shirt = await {
      sellingPrice: price,
      days: product.day,
      target: product.target,
      noOfCampaigns: product.campaign,
      step: 3,
      isDone: false,
    };
    try {
      const { data } = await API.graphql(
        graphqlOperation(updateProductTable, {
          input: { ...shirt, id: draftProductId },
        })
      );
      dispatch(
        draftId({
          draftProductId: data?.updateProductTable
            ? data?.updateProductTable?.id
            : data?.createProductTable?.id,
        })
      );
      setLoader(false);
      history.push("/describecampaign");
    } catch (err) {
      return err;
    }
  };

  return (
    <div>
      <Steppers
        head={t("set_duration")}
        text={`${t("continue")} >`}
        login={status}
        continue={() => {
          describeroute();
        }}
        back={() => designroute()}
        loader={loader}
      />
      <Container>
        <div className="price">
          <div className="price-top">
            <div className="price-left">
              <div>
                <div className="item-img">
                  <img
                    src={product.designnimg}
                    alt="t-shirt"
                    width={200}
                    height={200}
                  />
                </div>
              </div>
              <div className="item-describe">
                <p>{product.shirt.name}</p>
                <p>
                  <span>{t(product.shirt.type)}</span>
                </p>
                <p>
                  <b>{t("want_to_sell")}</b>
                  <input
                    type="number"
                    placeholder="0"
                    onChange={(e) => setprice(e.target.value)}
                    value={price}
                  />
                  <b>€</b>
                  <br />
                  <span>
                    {t("cost")}: {parseInt(product.shirt.cost)}€
                  </span>
                  {err && <p className="cost-err">{t("cost-err")}</p>}
                </p>
              </div>
            </div>
            <div className="price-right">
              <h4>{t("campaign_long")}</h4>
              <p>{t("able_to_decide")}</p>
              <div className="price-slider">
                <Slider
                  marks={days}
                  min={0}
                  max={30}
                  defaultValue={0}
                  step={1}
                  setday={setday}
                  value={day}
                />
                <input
                  type="number"
                  placeholder="0 day"
                  value={day}
                  disabled
                  onChange={(e) => setday(e.target.value)}
                />
              </div>
            </div>
          </div>
          <hr />
          <div className="price-bottom">
            <div className="price-right">
              <h4>{t("sales_target")}</h4>
              <p>{t("informational_purpose")}</p>
              <div className="price-slider">
                <Slider
                  marks={sales}
                  min={5}
                  max={100}
                  defaultValue={5}
                  step={1}
                  settarget={settarget}
                  value={target}
                />
                <input
                  type="number"
                  placeholder=""
                  value={target}
                  onChange={(e) => settarget(e.target.value)}
                  style={{ marginLeft: "15px" }}
                />
              </div>
            </div>
            <div className="bottom-right">
              <p>
                {t("clothes_sell-i")} {target} {t("clothes_sell-m")} &nbsp;
                {campaign}
                {
                  <ArrowDropDownIcon
                    onClick={() => {
                      target > 0 && setcampaignstyle((prev) => !prev);
                    }}
                    style={{ cursor: "pointer", marginLeft: "-5px" }}
                  />
                }
                {t("clothes_sell-l")}
              </p>
              <div className="campigns-div">
                <ul className={campaignstyle ? "show" : "hidden"}>
                  {campaigns_array.map((val, ind) => {
                    return <li onClick={() => No_compaigns(val)}>{val}</li>;
                  })}
                </ul>
              </div>
              {!campaignstyle && (
                <>
                  <span className="earn">{tgain}€</span>
                  <span>
                    i.e {gain}€ {t("per-sold")}
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      </Container>
      {msg || errMsg ? <Snackbar message={msg} errMessage={errMsg} /> : null}
    </div>
  );
};

export default Setprice;
